/**
 * Inverse of `SmartlingLocaleRename` in `libs/intl-tooling/projects.ts`, which maps Smartling
 * codes to BCP-47 on download. That package is build-time only and is not a dependency here,
 * so these entries are duplicated and must be updated together.
 */
export const SMARTLING_LOCALE_OVERRIDES: Record<string, string> = {
  ceb: 'cb',
  'es-419': 'es-LA',
  fil: 'fp-PH',
  kok: 'vb',
  mai: 'ma',
}

export function getSmartlingLocale(displayLanguage: string): string {
  return SMARTLING_LOCALE_OVERRIDES[displayLanguage] ?? displayLanguage
}
